<template>
    <div>
        <div class=" border border-dark p-4 mt-4 rounded-8">
            <div class="title-dark">
                Información de la empresa
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group position-relative">
                        <label for="client-logo" class="form-label">Logo Cliente</label>

                        <div v-if="newUser.logo_cliente.name"
                            style="
                                position:relative;
                                background: white;
                                padding: 0.5em 1em !important;
                                border: 1px solid #000;
                                border-radius: 1em;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                max-width: 150px;
                            "
                        >
                            <img src="" ref="profilePhotoDisplay" class="w-50px" style="max-height:130px;" />
                            <span @click="limpiarLogo"
                                style="position: absolute;
                                top: 10px;
                                right: 20px;
                                font-weight: 600;
                                color: red;
                                cursor: pointer;"
                                >
                                X
                            </span>
                        </div>
                        <input v-else
                            id="photo"
                            v-on:change="attachImage"
                            ref="profilePhoto"
                            type="file"
                            class="form-control"
                            style="padding: 3.5em;"
                        >
                        <p class="lh-sm mt-2 small text-dark"><small>Se recomienda 300px X 300px. Formatos compatibles JPG, JPEG y PNG</small></p>
                    </div>
                </div>
                <div class="col-md-6">
                            <div class="form-group">
                                <label for="client-name" class="form-label">Nombre de la Empresa</label>
                                <input
                                    type="text"
                                    v-model="newClient.name"
                                    class="form-control"
                                    placeholder="Nombre del cliente"
                                    aria-label="Nombre del cliente"
                                    id="client-name"
                                    required="required"
                                />
                            </div>
                            <div class="form-group">
                                <label for="client-website" class="form-label">Sitio Web</label>
                                <input
                                    type="text"
                                    v-model="newClient.website"
                                    class="form-control"
                                    placeholder="Sitio Web"
                                    aria-label="Sitio Web"
                                    id="client-website"
                                />
                            </div>


                </div>
            </div>

            <div class="title-dark mt-3">
                Nivel del plan empresarial
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <select
                        v-model="newClient.licencia"
                        @change="dataLicence($event)" required="required"
                        class="form-control" id="client-plan">
                            <option value="" disabled selected>Seleccione una licencia</option>
                            <option v-for="r of licencia" :key="r.id" :value="r.id"
                            :data-users="r.accepted_users"
                            :data-routes="r.accepted_routes"
                            :data-courses="r.accepted_courses" >
                                {{ r.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <a :href="'/dashboard/licences/'+newClient.licencia" class="text-primary text-decoration-underline pt-1 lh-lg"> Editar plan<i class="fa-solid fa-pen-to-square fs-4  ms-2"></i></a>
                </div>
            </div>

            <div>
                <div class="title-dark mt-3">
                    Etapa de la Empresa:
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <select v-model="newClient.etapa_empresa" class="form-control" id="client-etapa">
                                <option value="">Seleccione etapa...</option>
                                <option value="free_trial">Free Trial</option>
                                <option value="pago">Pago</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-auto">
                    <div class="form-group">
                        <div class="d-flex align-items-center gap-3">
                            <i class="fa-solid fa-users fa-2x text-primary"></i>
                            <!-- <select type="text" class="form-control w-auto py-0 px-2" id="client-users">
                                <option value="100">100</option>
                            </select> -->
                            <input
                                type="text"
                                value=""
                                placeholder="0"
                                class="form-control"
                                id="license-users"
                                style="width:50px;"
                                disabled
                            />
                            <div class="small">Usuarios y/o colaboradores</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-auto">
                    <div class="form-group">
                        <div class="d-flex align-items-center gap-3">
                            <i class="fa-solid fa-book-open fa-2x text-primary"></i>
                            <input
                                type="text"
                                value=""
                                placeholder="0"
                                class="form-control"
                                id="license-courses"
                                style="width:50px"
                                disabled
                            />
                            <!-- <select type="text" class="form-control w-auto py-0 px-2" id="client-users">
                                <option value="100">100</option>
                            </select> -->
                            <div class="small">Cursos disponibles</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-auto">
                    <div class="form-group">
                        <div class="d-flex align-items-center gap-3">
                            <img src="/img/icono-ruta.png" width="25px">
                            <input
                                type="text"
                                value=""
                                placeholder="0"
                                class="form-control"
                                id="license-routes"
                                style="width:50px"
                                disabled
                            />
                            <!-- <select type="text" class="form-control w-auto py-0 px-2" id="client-routes">
                                <option value="100">100</option>
                            </select> -->
                            <div class="small">Rutas de aprendizaje</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="title-dark my-3">
                Creación Administrador Cliente
            </div>
            <div class="row">
                <div class="col-md-6 py-0">
                    <div class="form-group">
                        <label for="client-name-admin" class="form-label">Nombres</label>
                        <input
                            type="text"
                            required="required"
                            v-model="newUser.firstname"
                            class="form-control"
                            placeholder="Nombre Usuario"
                            aria-label="Nombre Usuario"
                            id="client-name-admin"
                        />
                    </div>
                </div>
                <div class="col-md-6 py-0">
                    <div class="form-group">
                        <label for="client-lastname-admin" class="form-label">Apellidos</label>
                        <input
                            type="text"
                            required="required"
                            v-model="newUser.lastname"
                            class="form-control"
                            placeholder="Apellidos Usuario"
                            aria-label="Apellidos Usuario"
                            id="client-lastname-admin"
                        />
                    </div>
                </div>
                <div class="col-md-6 py-0">
                    <div class="form-group">
                        <label for="client-mail-admin" class="form-label">Correo electrónico de contacto</label>
                        <input
                            @keyup="verificarEmail($event)"
                            @change="revisarEmailUnico($event)"
                            type="email"
                            required="required"
                            v-model="newUser.email"
                            class="form-control"
                            placeholder="Correo Electronico"
                            aria-label="Correo Electronico"
                            id="client-mail-admin"
                        />
                        <small style="color:red" class="d-none" id="validarCorreoTexto">El correo tiene un formato no valido.</small>
                    </div>
                </div>
                <div class="col-md-6 py-0">
                    <div class="form-group">
                        <label for="client-cellphone-admin" class="form-label">Celular</label>
                        <input
                            @keyup="verificarTelefono($event)"
                            type="text"
                            required="required"
                            v-model="newUser.cellphone"
                            class="form-control"
                            placeholder="Celular"
                            aria-label="Celular"
                            id="client-cellphone-admin"
                        />
                        <small style="color:red" class="d-none" id="validarCelular">El número de celular debe ser mayor a 9 digitos.</small>
                    </div>
                </div>
                <div class="col-md-6 py-0">
                    <div class="form-group">
                        <label for="client-position-admin" class="form-label">Cargo</label>
                        <input
                            type="text"
                            v-model="newUser.position"
                            class="form-control"
                            required="required"
                            placeholder="Cargo"
                            aria-label="Cargor"
                            id="client-position-admin"
                        />
                    </div>
                </div>
                <div class="col-md-6 py-0">
                    <div class="form-group">
                        <label for="client-area-admin" class="form-label">Área</label>
                        <input
                            type="text"
                            v-model="newUser.area"
                            class="form-control"
                            required="required"
                            placeholder="Area"
                            aria-label="Area"
                            id="client-area-admin"
                        />
                    </div>
                </div>
                <div class="col-md-6 py-0">
                    <label for="client-level-admin" class="form-label">Nivel de área</label>
                        <input
                            type="text"
                            v-model="newUser.level"
                            class="form-control"
                            required="required"
                            placeholder="Nivel"
                            aria-label="Nivel"
                            id="client-level-admin"
                        />
                </div>
                <!-- <div class="col-md-6">
                    <div class="form-group">
                        <label for="client-role-admin" class="form-label">Rol</label>
                        <select
                            v-model="newUser.role"
                            class="form-control"
                            id="student-role"
                        >
                            <option value="" disabled selected>Seleccione un rol de la cuenta</option>
                            <option
                                v-for="r of roles"
                                :key="r.id"
                                :value="r.name"
                            >
                                {{ r.name }}
                            </option>
                        </select>

                    </div>
                </div> -->
            </div>

            <div class="d-flex justify-content-end gap-4 mt-5 flex-wrap">
                <button class="btn btn-utel btn-inverted px-4 d-none d-lg-block" data-bs-toggle="modal" data-bs-target="#descartarModal">Descartar</button>
                <button
                    id="agregar"
                    type="button"
                    data-bs-target="#modal"
                    @click="agregarCliente()"
                    class="btn btn-utel px-4 text-light"
                >
                    Crear empresa
                </button>
                <button class="btn btn-utel btn-inverted px-4 d-lg-none" data-bs-toggle="modal" data-bs-target="#descartarModal">Descartar</button>
                <button
                    id="agregar_usuarios_masivos"
                    type="button"
                    @click="agregarCliente(true)"
                    class="btn btn-utel px-4 text-light"
                >
                    Crear empresa y cargar usuarios masivos
                </button>
            </div>

        </div>

        <!-- MODALES  -->

        <!-- Modal Descartar -->
        <div class="modal fade" id="descartarModal" tabindex="-1"  data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="descartarModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="descartarModalLabel">Descartar</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        ¿Está seguro que desea borrar todos los campos del formulario?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger text-light" data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success text-light" data-bs-dismiss="modal">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Confirmación crea -->
        <button id="succesCreateBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal" data-bs-target="#succesCreate">
        </button>
        <div class="modal fade" id="succesCreate" tabindex="-1"  data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="succesCreateLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="succesCreateLabel">Creación</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha creado<br>la empresa correctamente.
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light" data-bs-dismiss="modal">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { assertDeclareTypeAlias } from '@babel/types';

export default {
    props: ["get", "headertab","licences","rol",'redirect', 'urlvalidateemail'],
    data() {
        return {
            headersTabs: this.headertab,
            roles: this.rol,
            url: this.get,
            licencia:this.licences,
            desserts: [],
            edit: [],
            destroy: [],
            newClient: { name: "", licencia: '', logo_cliente: '', etapa_empresa: '' },
            newUser: {
                logo_cliente: '',
                firstname: "",
                lastname: "",
                role:'admin',
                cellphone:'',
                position:'',
                area:'',
                level:'',
                email:''
            },
        };
    },
    mounted() {
        this.getData();
        console.log("role: ",this.redirect);
    },
    methods: {
        getData() {
            axios.get(this.url + "?withUsers=true").then((res) => {
                this.desserts = res.data;
                console.log(this.desserts);
            });
        },
        dataLicence(e) {
            let users =  e.target.selectedOptions[0].dataset.users;
            let routes =  e.target.selectedOptions[0].dataset.routes;
            let courses =  e.target.selectedOptions[0].dataset.courses;
            document.getElementById("license-users").value = users;
            document.getElementById("license-routes").value = routes;
            document.getElementById("license-courses").value = courses;
        },
        attachImage() {
            this.newUser.logo_cliente = this.$refs.profilePhoto.files[0];
            this.newClient.logo_cliente = this.$refs.profilePhoto.files[0];
            let reader = new FileReader();
            reader.addEventListener('load', function() {
                this.$refs.profilePhotoDisplay.src = reader.result;
            }.bind(this), false);

            reader.readAsDataURL(this.newUser.logo_cliente);
        },
        agregarCliente(massive = false) {
            let btn = document.getElementById("agregar");
            let succesCreateBtn = document.getElementById("succesCreateBtn");

            const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            if(!this.validarDatos()) return;
            btn.textContent = "Procesando ...";

            var data = new FormData();
            data.append('data', JSON.stringify(this.newClient));
            data.append('file', this.newClient.logo_cliente);

            axios
                .post(this.url, data, config)
                .then((res) => {
                    this.newClient = { name: "" };
                    btn.textContent = res.data.message;
                    succesCreateBtn.click();
                    if (res.status == '200') {
                        this.agregarUserCliente(res.data.client,massive);
                    }

                })
                .catch((err) => {});
        },
        agregarUserCliente($client,massive = false) {

            if(!this.validarDatos()) return;
            console.log('/client/'+$client+'/users');
            this.newUser.client = $client;
            axios
                .post('/client/'+$client+'/users', this.newUser)
                .then((res) => {
                    this.newUser = { name: "" };
                    if (res.status == '200') {
                        if(massive){
                            window.location.href = this.redirect +'?openModal';
                            return
                        }
                        window.location.href = '/dashboard/clients';
                    }
                })
                .catch((err) => {
                    this.error = err.response.data.errors;
                });
        },
        verificarEmail(val) {
            const value = val.target.value;
            let correo = document.getElementById('client-mail-admin');
            let validarCorreoTexto = document.getElementById('validarCorreoTexto');
            if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value)){
                correo.style.cssText = "border-color:black";
                validarCorreoTexto.classList.remove('d-block');
                validarCorreoTexto.classList.add('d-none');
                this.desactivarBotones(false);
            } else {
                this.desactivarBotones(true);
                correo.style.cssText = "border-color:red";
                validarCorreoTexto.classList.remove('d-none');
                validarCorreoTexto.classList.add('d-block');
            }
        },
        revisarEmailUnico(event){
            const value = event.target.value;
            let btn = document.getElementById("agregar");
            console.log(this.urlvalidateemail);
            axios
                .post(this.urlvalidateemail, { "email": value})
                .then((res) => {
                    const existsEmail = res.data;
                    console.log(existsEmail);
                    if(!existsEmail) {
                        btn.setAttribute("disabled", "disabled");
                        btn.textContent = "El email registrado ya existe";
                        this.$swal("El email registrado ya existe");
                        this.desactivarBotones(true);
                        return;
                    }

                    this.desactivarBotones(false);
                    btn.removeAttribute("disabled", "disabled");
                    btn.textContent = "Crear empresa";
                })
        },
        verificarTelefono(val) {
            const value = val.target.value;
            let celular = document.getElementById('client-cellphone-admin');
            let validarcelularTexto = document.getElementById('validarCelular');
            if (value.length >= 9){
                celular.style.cssText = "border-color:black";
                validarcelularTexto.classList.remove('d-block');
                validarcelularTexto.classList.add('d-none');
                this.desactivarBotones(false);
            } else {
                this.desactivarBotones(true);
                celular.style.cssText = "border-color:red";
                validarcelularTexto.classList.remove('d-none');
                validarcelularTexto.classList.add('d-block');
            }
        },
        desactivarBotones(desactivado) {
            let btn = document.getElementById("agregar");
            let btn_user = document.getElementById("agregar_usuarios_masivos");

            if(desactivado){
                btn.setAttribute("disabled", "disabled");
                btn_user.setAttribute("disabled", "disabled");
                return;
            }

            btn.removeAttribute("disabled");
            btn_user.removeAttribute("disabled");

        },
        validarDatos() {
            let returnData = true;
            let client_plan = document.getElementById("client-plan");
            var elements = document.getElementsByTagName("input")
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].required) {
                    if(elements[i].value == "" || elements[i].value == undefined){
                        elements[i].style.cssText = "border-color:red";
                        returnData = false;
                    }
                    else{
                        elements[i].style.cssText = "border-color:black";
                    }
                }
            }

            if (client_plan.value == "" || client_plan.value == undefined ){
                client_plan.style.cssText = "border-color:red";
                returnData = false;
            }

            !returnData ? this.desactivarBotones(true) : this.desactivarBotones(false);

            return returnData;

        },
        limpiarLogo() {
            const vm = this
            vm.newUser.logo_cliente = "";
            vm.newClient.logo_cliente = "";
        }
    },
};
</script>
